<template>
  <div
    class="border py-2 px-2 rounded-md border-dashed border-[#E4E6EF] group flex-y-center gap-2 overflow-hidden"
  >
    <CAvatar
      class="!w-8 !h-8 overflow-hidden"
      v-if="image"
      :avatar-class="avatarClass"
      v-bind="{ image }"
    />
    <div class="w-full">
      <slot>
        <p
          class="text-sm font-bold text-dark-100 leading-130 line-clamp-1"
          :class="{ 'group-last:!text-green': course }"
        >
          {{ title?.length ? title : "-" }}
        </p>
      </slot>
      <p class="text-gray text-xs leading-130" :class="descriptionClass">
        {{ t(description) }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import CAvatar from "@/components/CAvatar.vue";

interface Props {
  title?: string;
  description: string;
  avatarClass?: string;
  course?: boolean;
  image?: boolean;
  descriptionClass?: string;
}

const { t } = useI18n();

withDefaults(defineProps<Props>(), {
  title: "-",
  description: "-",
});
</script>
